import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FilterFormsComponent, UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { Observable } from 'rxjs';

@Component({
  selector: 'thehubz-assets-sidebar',
  templateUrl: './assets-sidebar.component.html',
  styleUrls: ['./assets-sidebar.component.scss'],
  standalone: true,
  imports: [CommonModule, UiKitModule, ClientCoreModule, MatIconModule, TourMatMenuModule],
})
export class AssetsSidebarComponent {
  @Input() configObject!: AnyType;
  @Input() filterAssetFormData!: AnyType;
  @Input() selectedFilterObject!: AnyType;
  @Input() appliedFilters!: AnyType;
  @Input() gridSettingsKeySuffix!: string;
  @Input() formResetter!: Observable<{ _id: string; name: string; key: string } | undefined>;

  @Output() applyFilters = new EventEmitter<AnyType>();
  @Output() updateFormData = new EventEmitter<AnyType>();
  @Output() viewAssetTags = new EventEmitter<AnyType>();
  @Output() requestClose = new EventEmitter<AnyType>();

  @ViewChild('filterForms') filterForms!: FilterFormsComponent;
}
